/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserTrialUpdateRequest } from './userTrialUpdateRequest';

export type UserUpdateTrial = UserTrialUpdateRequest | null;
